import { RawMergeData } from './types';
import { ProcessStatus } from 'models/types';

export class MergeSummaryModel {
  id: string;
  status: ProcessStatus;
  mergedItemId: string;
  baseItemsIds: string[];
  image: string;

  constructor(rawMergeData: RawMergeData) {
    this.id = rawMergeData.id;
    this.status = rawMergeData.status;
    this.mergedItemId = rawMergeData.merged_item_id;
    this.baseItemsIds = rawMergeData.base_items;
    this.image = rawMergeData.image;
  }

  getProcessCardFormat() {
    return {
      id: this.id,
      name: `Merge ${this.id}`,
      status: this.status,
      image: this.image,
      baseType: 'Items',
      baseCount: this.baseItemsIds.length
    };
  }
}
